import ErrorIcon from 'Assets/icons/system-x.svg';
import React from 'react';
import { Flex, Alert } from 'antd';

import css from './Prescription.less';

interface ErrorMessageProps {
  title: string;
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ title, message }) => {
  return (
    <Alert
      type="error"
      showIcon={false}
      className={css.error}
      message={
        <Flex gap={12}>
          <img src={ErrorIcon} alt="" style={{ width: 24, height: 24 }} />
          <Flex vertical gap={4}>
            <div style={{ fontWeight: 600, fontSize: 16 }}>{title}</div>
            <div>{message}</div>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ErrorMessage;
